import React from 'react';
import VideoListItem from './VideoListItem';

const VideoList = props => {
	return (
		<div className="col-lg-4">
			<ul className="list-group">
				{props.videos.map(video =>
					<VideoListItem
						onVideoSelect={props.onVideoSelect}
						key={video.id.videoId}
						video={video}
					/>
				)}
			</ul>
		</div>
	);
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/VideoList.js